import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Icon } from '@haldor/ui';
import Spinner from '../../Elements/Spinner';
import './Search.scss';
var Search = /*#__PURE__*/function (_Component) {
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [props]);
    _defineProperty(_this, "throttle", function (func, immediate) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          this.timeout = null;
          if (!immediate) func.apply(this, args);
        };
        var callNow = immediate && !_this.timeout;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(later, _this.scrollLimit);
        if (callNow) func.apply(_this, args);
      };
    });
    _defineProperty(_this, "onSubmit", function () {
      var _this$props = _this.props,
        input = _this$props.input,
        onSubmit = _this$props.onSubmit;
      var value = _this.getValue();
      if (!_this.props.allowEmpty && value.query == '') {
        // Dont submit empty strings
        return false;
      }
      if (input != null && input.onSubmit != null) {
        input.onSubmit(value);
      }
      if (onSubmit != null) {
        onSubmit(value);
      }
    });
    _defineProperty(_this, "getValue", function () {
      var type = 'search';
      var query = _this.state.value;
      var modifier = null;
      if (_this.state.value.charAt(0) == '@') {
        type = 'picker';
        modifier = '@';
        query = _this.state.value.substr(1);
      }
      if (_this.state.value.charAt(0) == '#') {
        type = 'picker';
        modifier = '#';
        query = _this.state.value.substr(1);
      }
      if (_this.state.value.charAt(0) == '!') {
        type = 'picker';
        modifier = '!';
        query = _this.state.value.substr(1);
      }
      return {
        type: type,
        modifier: modifier,
        query: query
      };
    });
    _defineProperty(_this, "onValueChange", function (event) {
      var _this$props2 = _this.props,
        input = _this$props2.input,
        onChange = _this$props2.onChange;
      _this.setState({
        value: event.target.value
      }, function () {
        if (_this.getValue().type == 'picker') {
          var onSubmit = _this.throttle(_this.onSubmit);
          onSubmit();
          return;
        }
        if (_this.props.autoSearch) {
          var _onSubmit = _this.throttle(_this.onSubmit);
          _onSubmit();
          return;
        }
      });
      if (input != null && input.onChange != null) {
        input.onChange(event.target.value);
      }
      if (onChange != null) {
        onChange(event.target.value);
      }
    });
    _defineProperty(_this, "onKeyDown", function (event) {
      if (event.keyCode == 13) {
        _this.onSubmit(_this.state.value);
      }
    });
    _defineProperty(_this, "onIconClick", function () {
      _this.refs['input'].focus();
    });
    var _value = '';
    if (props.input != null && props.input.value != null) {
      _value = props.input.value;
    }
    _this.state = {
      value: _value
    };
    _this.timeout = null;
    _this.autoSearchLimit = 200;
    return _this;
  }
  _inherits(Search, _Component);
  return _createClass(Search, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "search-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-box-container",
        onClick: this.onIconClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-box-icon"
      }, this.props.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "Magnify"
      })), /*#__PURE__*/React.createElement("input", {
        type: "search",
        value: this.state.value,
        onChange: this.onValueChange,
        onKeyDown: this.onKeyDown,
        ref: "input",
        placeholder: this.props.placeholder
      })), /*#__PURE__*/React.createElement("div", {
        className: "search-children"
      }, this.props.children));
    }
  }]);
}(Component);
_defineProperty(Search, "defaultProps", {
  autoSearch: false,
  allowEmpty: false
});
export default Search;